import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CustomButtonComponent, GameLaunchService, RoomsInfoService, ScheduleService } from '@frontend/bingo/core';
import { CurrencyPipe } from '@frontend/vanilla/core';

import { FeatureIconComponent } from '../../shared/components/feature-icon/feature-icon.component';
import { FabGrabRoomComponent } from '../fabgrab-room/fabgrab-room.component';
import { FriendsComponent } from '../friends/friends.component';
import { MultiPriceComponent } from '../multi-price/multi-price.component';

@Component({
    selector: 'bg-buynow-body',
    templateUrl: 'buynow-body.component.html',
    providers: [CurrencyPipe],
    imports: [CurrencyPipe, CommonModule, FabGrabRoomComponent, FriendsComponent, CustomButtonComponent, FeatureIconComponent, MultiPriceComponent],
})
export class BuyNowBodyComponent implements OnInit {
    @Input() packageDetails: any;
    @Input() isInGameClient: boolean = false;

    packageName: string;
    totalGames: number;
    content: any = [];
    prebuyIconslist: any;
    prebuynavlist: any;
    clientConfig: any;
    package_room_details: any;
    roomsConfig: any = [];
    styleObj = {
        float: 'right',
    };
    counter: any = {};

    constructor(
        public dialogRef: MatDialogRef<BuyNowBodyComponent>,
        private gameLaunchService: GameLaunchService,
        private roomsInfoService: RoomsInfoService,
        private scheduleService: ScheduleService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}
    ngOnInit() {
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        }
        if (this.roomsConfig.length == 0) this.roomsConfig = this.clientConfig.rooms;

        this.package_room_details = this.packageDetails.game_details;
        this.prebuynavlist = this.clientConfig?.bingoCategories;
        this.prebuyIconslist = this.prebuynavlist?.find((x: any) => x.categoryType == 'rooms');
        if (this.packageDetails.type == 'package_bingo') {
            this.content = this.clientConfig?.packageGlobalMessages;
        }
        if (this.packageDetails.type == 'session_bingo') {
            this.content = this.clientConfig?.sessionGlobalMessages;
        }
        this.packageName = this.packageDetails.package_name;
        if (this.packageDetails.package_game_details) {
            this.totalGames = this.packageDetails.package_game_details.length;
        }
    }

    close() {
        this.dialogRef.close();
    }

    gameLaunch(sessionItem: any) {
        this.dialogRef.close();
        if (sessionItem && sessionItem.game_Info && sessionItem.game_Info[0]) {
            const data = sessionItem.game_Info[0];
            if (this.scheduleService.checkforscheduleData()) {
                const launchedRoom = this.scheduleService.getFeatureTypesbyRoomId(data.room_id);
                this.gameLaunchService.initiateGameLaunch(
                    launchedRoom.name,
                    'Bingo',
                    'Bingo',
                    launchedRoom.bingo_type,
                    'REGULAR',
                    this.roomsInfoService.getImage(launchedRoom.id, this.roomsConfig),
                    launchedRoom.id,
                    launchedRoom.isFavourite,
                    1, //this.position
                    1, //this.gridSize
                    '',
                    '',
                );
            }
        }
    }
}
